import React, { useState } from 'react';
import Swal from 'sweetalert2';
import './ContactSection.css';

const SERVICIO_DE_INTERES_OPTIONS = [
  { value: 'Timbrado', label: 'Timbrado' },
  { value: 'Timbrado especializado', label: 'Timbrado especializado' },
  { value: 'Gestión y conciliación  de CFDI', label: 'Gestión y conciliación de CFDI' },
  { value: 'Conectores para timbrado', label: 'Conectores para timbrado' },
  { value: 'Portales especializados', label: 'Portales especializados' },
  { value: 'Cancelación', label: 'Cancelación' },
  { value: 'Validación', label: 'Validación' },
  { value: 'Sistema de facturación en línea (FLO)', label: 'Sistema de facturación en línea (FLO)' },
  { value: 'Sistema de contabilidad en línea (FLO)', label: 'Sistema de contabilidad en línea (FLO)' },
  { value: 'Timbrado Corporativo, Timbrado Corporativo', label: 'Timbrado Corporativo' },
  { value: 'Emisión Timbrado , Emisión Timbrado', label: 'Emisión Timbrado' },
  { value: 'Timbrado JSON, Timbrado JSON', label: 'Timbrado JSON' },
  { value: 'Gestión de XML, Gestión de XML', label: 'Gestión de XML' },
  { value: 'Cancelación Masiva, Cancelación Masiva', label: 'Cancelación Masiva' },
  { value: 'Generación PDF, Generación PDF', label: 'Generación PDF' },
  { value: 'Validación LCO, Validación LCO', label: 'Validación LCO' },
  { value: 'Validación LRFC, Validación LRFC', label: 'Validación LRFC' },
  { value: 'Validación XML, Validación XML', label: 'Validación XML' },
  { value: 'Validación EFOS, Validación EFOS', label: 'Validación EFOS' },
  { value: 'Almacén CFDI, Almacén CFDI', label: 'Almacén CFDI' },
  { value: 'Póliza de servicio, Póliza de servicio', label: 'Póliza de servicio' },
  { value: 'Plantilla PDF Personalizada , Plantilla PDF Personalizada', label: 'Plantilla PDF Personalizada' },
  { value: 'efisco, eFisco', label: 'efisco, eFisco' },
  { value: 'Envío de Correo, Envío de Correo', label: 'Envío de Correo' },
  { value: 'Validaciones smarter, Validaciones smarter', label: 'Validaciones smarter' },
  { value: 'Hospedaje y dominio Web, Hospedaje y dominio Web', label: 'Hospedaje y dominio Web' },
  { value: 'efisco® core, efisco® core', label: 'efisco® core' },
  { value: 'efisco® CORP, efisco® CORP', label: 'efisco® CORP' },
  { value: 'efisco® CORP+Power BI, efisco® CORP+Power BI', label: 'efisco® CORP+Power BI' },
  { value: 'Póliza de servicio smarter®, Póliza de servicio smarter®', label: 'Póliza de servicio smarter®' },
  { value: 'Póliza de servicio smarter® (Gratuita), Póliza de servicio smarter® (Gratuita)', label: 'Póliza de servicio smarter® (Gratuita)' },
  { value: 'DF Timbrado , DF Timbrado', label: 'DF Timbrado' },
  { value: 'DF SICAI Web, DF SICAI Web', label: 'DF SICAI Web' },
  { value: 'DF SICAI, DF SICAI', label: 'DF SICAI' },
  { value: 'DF Addendas, DF Addendas', label: 'DF Addendas' },
  { value: 'DF Asesoria general, DF Asesoria general', label: 'DF Asesoria general' },
  { value: 'DF Conectores, DF Conectores', label: 'DF Conectores' },
  { value: 'DF Creación de Apps a la medida, DF Creación de Apps a la medida', label: 'DF Creación de Apps a la medida' },
  { value: 'DF Hosting, DF Hosting', label: 'DF Hosting' },
  { value: 'Desarrollo a la medida, Desarrollo a la medida', label: 'Desarrollo a la medida' },
  { value: 'Envío por correo, Envío por correo', label: 'Envío por correo' },
  { value: 'Emisión de Constancias NOM-151, Emisión de Constancias NOM-151', label: 'Emisión de Constancias NOM-151' },
  { value: 'Timbrado Corporativo (FLO), Timbrado Corporativo (FLO)', label: 'Timbrado Corporativo (FLO)' },
  { value: 'Servicio de Descarga Masiva (FLO), Servicio de Descarga Masiva (FLO)', label: 'Servicio de Descarga Masiva (FLO)' },
  { value: 'Dominio y Hosting (FLO), Dominio y Hosting (FLO)', label: 'Dominio y Hosting (FLO)' },
  { value: 'Desarrollo de plantillas (FLO), Desarrollo de plantillas (FLO)', label: 'Desarrollo de plantillas (FLO)' },
  { value: 'Desarrollo de Addendas (FLO), Desarrollo de Addendas (FLO)', label: 'Desarrollo de Addendas (FLO)' }
];

const CUANTOS_TIMBRES_OPTIONS = [
  'Menos de 10,000',
  '10,000 - 50,000',
  '50,001 - 100,000',
  '100,001 - 200,000',
  'Más de 200,000'
];

const SITUACION_ACTUAL_OPTIONS = [
  { value: 'Pruebas CFDI 4.0', label: 'Quiero comenzar pruebas en CFDI 4.0' },
  { value: 'Estoy evaluando un nuevo PAC.', label: 'Estoy evaluando un nuevo PAC.' },
  { value: 'Tengo un sistema ERP a la medida o comercial (SAP, Odoo, Microsoft,...) y necesito un PAC.', label: 'Tengo un desarrollo a la medida y necesito un PAC.' },
  { value: 'Busco un PAC alterno para balancear carga de timbrado.', label: 'Busco un PAC alterno para balancear carga de timbrado.' },
  { value: 'No tengo PAC, necesito uno.', label: 'No tengo PAC, necesito uno' }
];

const ContactSection = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    correo: '',
    telefono: '',
    empresa: '',
    servicio_de_interes: '',
    cuantos_timbres_anuales_necesitas_: '',
    que_opcion_describe_mejor_tu_situacion_actual_: '',
    en_que_podemos_ayudarte_: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const portalId = '1735765';
      const formId = '31fd5863-be40-42d8-8d6b-61ef8455b3ba';
      const region = 'na1';

      // Obtener cookie de seguimiento de HubSpot si está presente
      const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : null;
      };
      const hutk = getCookie('hubspotutk');

      const rawFields = [
        { name: 'email', value: formData.correo.trim() },
        { name: 'firstname', value: formData.nombre.trim() },
        { name: 'lastname', value: formData.apellido.trim() },
        { name: 'phone', value: formData.telefono.trim() },
        { name: 'company', value: formData.empresa.trim() },
        { name: 'servicio_de_interes', value: formData.servicio_de_interes },
        { name: 'cuantos_timbres_anuales_necesitas_', value: formData.cuantos_timbres_anuales_necesitas_ },
        { name: 'que_opcion_describe_mejor_tu_situacion_actual_', value: formData.que_opcion_describe_mejor_tu_situacion_actual_ },
        { name: 'en_que_podemos_ayudarte_', value: formData.en_que_podemos_ayudarte_.trim() }
      ];

      // Enviar únicamente campos con valor para evitar fallos de validación en HubSpot
      const fields = rawFields.filter((f) => f.value && f.value.length > 0);

      const payload = {
        fields,
        context: {
          pageUri: window.location.href,
          pageName: document.title || 'Digital Factura - Contacto',
          ...(hutk ? { hutk } : {})
        }
      };

      const response = await fetch(
        `https://api-${region}.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        }
      );

      if (!response.ok) {
        throw new Error('HubSpot submission failed');
      }

      Swal.fire({
        title: '¡Mensaje Enviado!',
        text: 'Muchas gracias por contactarnos. Un asesor de Digital Factura te contactará en breve.',
        icon: 'success',
        confirmButtonColor: '#C8102E'
      });

      // Limpiar formulario
      setFormData({
        nombre: '',
        apellido: '',
        correo: '',
        telefono: '',
        empresa: '',
        servicio_de_interes: '',
        cuantos_timbres_anuales_necesitas_: '',
        que_opcion_describe_mejor_tu_situacion_actual_: '',
        en_que_podemos_ayudarte_: ''
      });
    } catch (error) {
      console.error('Error al enviar formulario a HubSpot:', error);
      Swal.fire({
        title: 'Error',
        text: 'Ocurrió un problema al enviar tu información. Por favor comunícate a nuestras líneas telefónicas.',
        icon: 'error',
        confirmButtonColor: '#C8102E'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contacto" className="df-contact-section">
      <div className="df-contact-container">
        {/* Columna Izquierda: Información de Contacto */}
        <div className="df-contact-info-col">
          <span className="df-contact-badge">Contáctanos</span>

          <h2 className="df-contact-title">
            <b>¡Contáctanos!</b>
          </h2>

          <p className="df-contact-desc">
            Déjanos tus datos y un asesor de Digital Factura te contactará para ayudarte a elegir la solución ideal para tu negocio.
          </p>

          <div className="df-contact-channels">
            {/* Tarjeta Teléfonos */}
            <div className="df-contact-channel-card">
              <span className="df-contact-channel-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z"></path>
                </svg>
              </span>
              <div className="df-contact-channel-details">
                <span className="df-contact-channel-label">LLÁMANOS</span>
                <a href="tel:3336337809" className="df-contact-channel-link">33.3633.7809</a>
                <a href="tel:3336367965" className="df-contact-channel-link">33.3636.7965</a>
                <a href="tel:3336368722" className="df-contact-channel-link">33.3636.8722</a>
              </div>
            </div>

            {/* Tarjeta Correo */}
            <div className="df-contact-channel-card">
              <span className="df-contact-channel-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <rect x="3" y="5" width="18" height="14" rx="2"></rect>
                  <path d="M3 7l9 6 9-6"></path>
                </svg>
              </span>
              <div className="df-contact-channel-details">
                <span className="df-contact-channel-label">ESCRÍBENOS</span>
                <a href="mailto:soporte@decaber.com" className="df-contact-channel-link">
                  soporte@decaber.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Columna Derecha: Formulario */}
        <form className="df-contact-form" onSubmit={handleSubmit}>
          {/* Nombre y Apellido */}
          <div className="df-form-row">
            <label className="df-form-label">
              Nombre
              <input
                type="text"
                name="nombre"
                required
                className="df-form-input"
                value={formData.nombre}
                onChange={handleChange}
                placeholder="Tu nombre"
              />
            </label>

            <label className="df-form-label">
              Apellido
              <input
                type="text"
                name="apellido"
                className="df-form-input"
                value={formData.apellido}
                onChange={handleChange}
                placeholder="Tu apellido"
              />
            </label>
          </div>

          {/* Correo y Teléfono */}
          <div className="df-form-row">
            <label className="df-form-label">
              Correo electrónico *
              <input
                type="email"
                name="correo"
                required
                className="df-form-input"
                value={formData.correo}
                onChange={handleChange}
                placeholder="ejemplo@empresa.com"
              />
            </label>

            <label className="df-form-label">
              Número de teléfono
              <input
                type="tel"
                name="telefono"
                className="df-form-input"
                value={formData.telefono}
                onChange={handleChange}
                placeholder="10 dígitos"
              />
            </label>
          </div>

          {/* Empresa */}
          <label className="df-form-label">
            Nombre de la empresa
            <input
              type="text"
              name="empresa"
              className="df-form-input"
              value={formData.empresa}
              onChange={handleChange}
              placeholder="Empresa o Razón Social"
            />
          </label>

          {/* Servicio de Interés */}
          <label className="df-form-label">
            Servicio de interés
            <select
              name="servicio_de_interes"
              className="df-form-input df-form-select"
              value={formData.servicio_de_interes}
              onChange={handleChange}
            >
              <option value="">Selecciona un servicio</option>
              {SERVICIO_DE_INTERES_OPTIONS.map((opt, idx) => (
                <option key={idx} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </label>

          {/* Timbres Anuales y Situación Actual */}
          <div className="df-form-row">
            <label className="df-form-label">
              ¿Cuántos timbres anuales necesitas?
              <select
                name="cuantos_timbres_anuales_necesitas_"
                className="df-form-input df-form-select"
                value={formData.cuantos_timbres_anuales_necesitas_}
                onChange={handleChange}
              >
                <option value="">Selecciona un rango</option>
                {CUANTOS_TIMBRES_OPTIONS.map((opt, idx) => (
                  <option key={idx} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </label>

            <label className="df-form-label">
              ¿Qué opción describe mejor tu situación actual?
              <select
                name="que_opcion_describe_mejor_tu_situacion_actual_"
                className="df-form-input df-form-select"
                value={formData.que_opcion_describe_mejor_tu_situacion_actual_}
                onChange={handleChange}
              >
                <option value="">Selecciona tu situación</option>
                {SITUACION_ACTUAL_OPTIONS.map((opt, idx) => (
                  <option key={idx} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </label>
          </div>

          {/* ¿En qué podemos ayudarte? */}
          <label className="df-form-label">
            ¿En qué podemos ayudarte?
            <textarea
              rows="4"
              name="en_que_podemos_ayudarte_"
              className="df-form-textarea"
              value={formData.en_que_podemos_ayudarte_}
              onChange={handleChange}
              placeholder="Cuéntanos más sobre tu requerimiento o proyecto..."
            />
          </label>

          <button
            type="submit"
            className="df-contact-submit-btn"
            disabled={loading}
          >
            {loading ? 'Enviando...' : 'Enviar'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactSection;
